export const accountRoutePaths = {
    root: "accounts/",
    list: "",
    add: "add",
    edit: "edit",
};
